import PropTypes from 'prop-types';
import React from 'react';

import Button from 'components/common/button';
import CloseModal from 'actions/modal/close_modal';
import Modal from 'components/lib/modal';
import NavigateBack from 'actions/current_location/navigate_back';
import Reload from 'actions/current_location/reload';

const CustomReportingErrorModal = ({ onRetry, onAbort }) => (
  <Modal className="conversationModal customReportingErrorModal">
    <div className="conversationModal-header">
      <div className="conversationModal-header-text">Oops!</div>
    </div>
    <div className="conversationModal-body">
      <p>We ran into an unexpected problem loading these reports.</p>
    </div>
    <div className="conversationModal-footer">
      <Button className="conversationModal-confirmButton" onClick={onRetry}>
        Try again
      </Button>
      <div className="conversationModal-footer-buttonDivider" />
      <Button className="conversationModal-confirmButton" onClick={onAbort}>
        Give up
      </Button>
    </div>
  </Modal>
);

CustomReportingErrorModal.propTypes = {
  onRetry: PropTypes.func.isRequired,
  onAbort: PropTypes.func.isRequired,
};

import connect from 'components/lib/connect';

export default connect(null, mapExecuteToProps)(CustomReportingErrorModal);

function mapExecuteToProps(executeAction) {
  let closeThen = action => {
    executeAction(CloseModal);
    executeAction(action);
  };

  return {
    onAbort: () => closeThen(NavigateBack),
    onRetry: () => closeThen(Reload),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/custom_reporting/custom_reporting_error_modal.jsx